import type { ACL, Entity, Persisted } from '@tunasong/schemas'

/** An `Entity` plus the one server-owned field a create may carry as a request: `acls` */
export type CreateEntityBody = Entity & { acls?: ACL[] }

/**
 * The POST body for a create. The server derives the ACLs from the stored parent (GH #1904,
 * #1958); the client sends `acls` only to ask for a private entity. An empty list is that
 * request: "no inherited grant for anyone", which the server answers with creator-only.
 * `parentId` comes from the parent when one is given.
 */
export const createEntityBody = ({
  entity,
  parent,
  isPrivate,
}: {
  entity: Entity
  parent: Persisted<Entity> | null
  isPrivate: boolean
}): CreateEntityBody => ({
  ...entity,
  parentId: parent?.id ?? entity.parentId,
  ...(isPrivate ? { acls: [] } : {}),
})
